import { Company, Deal, Contact } from "../../../../models";
import { Filter } from "../../../common";
import { API } from "../../..";
import { DataAPI_Base, GetAPI_Base } from "../base";

class GetAPI_Deals extends GetAPI_Base<Deal> {
	constructor() {
		super("deals");
	}

	public async activeAndPrimary(dealIds: string[]) {
		const filter = {
			type: "OR",
			fields: dealIds.map((id) => {
				return {
					type: "AND",
					fields: {
						id: id,
						isActive: true,
						isConfigOnly: false,
					},
				} as Filter<Deal>;
			}),
		} as Filter<Deal>;

		return super.byFilter(filter);
	}

	/**
	 * @param [loadAll=false]  Otherwise retrieves only active and primary deals
	 */
	public async byCompany(company: Company, loadAll: boolean = false) {
		if (!company.dealIds || company.dealIds.length === 0) return [];
		const deals = loadAll ? await super.byIds(company.dealIds) : await this.activeAndPrimary(company.dealIds);
		return deals;
	}

	public async byContact(contact: Contact) {
		const companies = await API.Data.Companies.get.byContact(contact);
		const company = companies[0];
		return this.byCompany(company);
	}
}

export class DealsAPI extends DataAPI_Base<Deal> {
	get: GetAPI_Deals;

	constructor() {
		super("deals");
		this.get = new GetAPI_Deals();
	}
}
